import { Record as CookieRecord } from '../Storage/types';

export default class Result<T = unknown> {
  public constructor(public readonly data: T, public readonly success: boolean = true) {}
}

export class EmptyResult extends Result<undefined> {
  public constructor() {
    super(undefined);
  }
}

export class RedirectResult extends Result<null> {
  public constructor(public readonly url: string, public readonly status: number) {
    super(null);
  }
}

export class HttpResult<T = unknown> extends Result<T> {
  public readonly headers: CookieRecord[];

  public constructor(
    public readonly data: T,
    headers: Headers = new Headers(),
    public readonly success: boolean = true,
  ) {
    super(data, success);
    this.headers = this.getCookieHeaders(headers);
  }

  private getCookieHeaders(headers: Headers): CookieRecord[] {
    return headers.getSetCookie().map((cookie) => {
      const [keyValue, ...options] = cookie.split(';');
      const [key, value] = keyValue.split('=').map((s) => s.trim());
      const cookieOptions = Object.fromEntries(
        options.map((opt) => {
          const [k, v = true] = opt.trim().split('=');
          const lowerK = k.toLowerCase();
          if (lowerK === 'expires') {
            return [lowerK, this.parseExpires(v)];
          }
          return [lowerK, v];
        }),
      );
      return { key, value, options: cookieOptions };
    });
  }

  private parseExpires(expires: string | true): Date | undefined {
    if (expires === true) return undefined;
    const parsed = Date.parse(expires);
    return isNaN(parsed) ? undefined : new Date(parsed);
  }
}
